export enum REQUEST_ACCESS_TYPE {
    None = 0,
    ChatBot = 1,
    AgentPortal = 2
}